import _toConsumableArray from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getImUser } from '@/api/permission/user';
import { getIMReply } from '@/api/system/message';
import Im from "./Im";
export default {
  name: 'UserList',
  components: {
    Im: Im
  },
  data: function data() {
    return {
      drawer: false,
      activeTab: 'reply',
      userList: [],
      replyList: [],
      loading: false,
      replyLoading: false,
      visible: false,
      finish: false,
      listQuery: {
        keyword: '',
        currentPage: 1,
        pageSize: 20
      }
    };
  },
  created: function created() {},
  computed: _objectSpread({}, mapGetters(['userInfo'])),
  watch: {
    activeTab: function activeTab(val) {
      if (val === 'contacts' && !this.userList.length) {
        this.getUserList();
      }
    }
  },
  methods: {
    init: function init() {
      var _this2 = this;
      this.finish = false;
      this.drawer = true;
      this.listQuery.currentPage = 1;
      this.listQuery.keyword = '';
      this.activeTab = 'reply';
      this.userList = [];
      this.replyList = [];
      this.getReplyList();
      this.$nextTick(function () {
        _this2.bindScroll();
      });
    },
    bindScroll: function bindScroll() {
      var _this = this,
        vBody = _this.$refs.userList;
      vBody.addEventListener("scroll", function () {
        if (vBody.scrollHeight - vBody.clientHeight - vBody.scrollTop <= 300 && !_this.loading && !_this.finish) {
          _this.listQuery.currentPage += 1;
          _this.getUserList();
        }
      });
    },
    getReplyList: function getReplyList() {
      var _this3 = this;
      this.replyLoading = true;
      getIMReply().then(function (res) {
        _this3.replyList = res.data.list;
        _this3.replyLoading = false;
      });
    },
    getUserList: function getUserList() {
      var _this4 = this;
      this.loading = true;
      getImUser(this.listQuery).then(function (res) {
        if (res.data.list.length < _this4.listQuery.pageSize) _this4.finish = true;
        _this4.userList = [].concat(_toConsumableArray(_this4.userList), _toConsumableArray(res.data.list));
        _this4.loading = false;
      });
    },
    search: function search() {
      this.userList = [];
      this.finish = false;
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 20;
      this.getUserList();
    },
    updateReply: function updateReply(data, isAdd) {
      var boo = false;
      var len = this.replyList.length;
      for (var i = 0; i < len; i++) {
        if (data.formUserId === this.replyList[i].id) {
          if (isAdd) this.replyList[i].unreadMessage += 1;
          this.replyList[i].latestMessage = data.formMessage;
          this.replyList[i].messageType = data.messageType;
          this.replyList[i].latestDate = data.latestDate;
          boo = true;
          break;
        }
      }
      if (boo) return;
      if (isAdd) data.unreadMessage = 1;
      data.latestMessage = data.formMessage;
      data.id = data.formUserId;
      this.replyList.unshift(data);
    },
    updateLatestMessage: function updateLatestMessage(data) {
      var boo = false;
      var len = this.replyList.length;
      for (var i = 0; i < len; i++) {
        if (data.toUserId === this.replyList[i].id) {
          this.replyList[i].latestMessage = data.toMessage;
          this.replyList[i].messageType = data.messageType;
          this.replyList[i].latestDate = data.latestDate;
          boo = true;
          break;
        }
      }
      if (boo) return;
      var item = {
        account: data.toAccount,
        headIcon: data.toHeadIcon,
        id: data.toUserId,
        latestDate: data.latestDate,
        latestMessage: data.toMessage,
        messageType: data.messageType,
        realName: data.toRealName,
        unreadMessage: 0
      };
      this.replyList.unshift(item);
    },
    toggleBlink: function toggleBlink() {
      var boo = this.replyList.some(function (o) {
        return o.unreadMessage;
      });
      this.$emit('changeTwinkle', boo);
    },
    readInfo: function readInfo(item, isReply) {
      var socket = this.$store.getters.socket;
      var updateReadMessage = {
        method: "UpdateReadMessage",
        formUserId: item.id,
        token: this.$store.getters.token
      };
      socket.send(JSON.stringify(updateReadMessage));
      if (isReply) {
        item.unreadMessage = 0;
      } else {
        for (var i = 0; i < this.replyList.length; i++) {
          if (item.id === this.replyList[i].id) {
            this.replyList[i].unreadMessage = 0;
            break;
          }
        }
      }
      this.toggleBlink();
      this.$refs.WeforsysIm.list = [];
      //获取消息列表
      var messageList = {
        method: "MessageList",
        toUserId: item.id,
        formUserId: this.userInfo.userId,
        token: this.$store.getters.token,
        currentPage: 1,
        pageSize: 30,
        sord: "desc"
      };
      socket.send(JSON.stringify(messageList));
      this.$refs.WeforsysIm.init(item);
    },
    getMsgText: function getMsgText(text, type) {
      var message = '';
      switch (type) {
        case 'voice':
          message = '[语音]';
          break;
        case 'image':
          message = '[图片]';
          break;
        default:
          message = text;
          break;
      }
      return message;
    },
    handleClose: function handleClose(done) {
      this.$refs.WeforsysIm.colseIM();
      var vBody = this.$refs.userList;
      vBody.removeEventListener("scroll", function () {});
      done();
    }
  }
};